import { firestore, getQuestionsCollection } from '../common/lib/firebase'

export default (docId: string, roomId: string, data: any): Promise<void> => {
  const collectionName = getQuestionsCollection(roomId)
  return firestore.collection(collectionName).doc(docId).update(data)
}
